export const EMAIL_REGEX =
  /^[A-Za-z0-9_%+-][A-Za-z0-9._%+-]*@[a-z]+(\.[a-z]+)*\.[a-z]{2,4}$/
